import React, { useEffect, useState, useCallback } from 'react';
import { Col, Container, Row } from "reactstrap";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import { Link, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Config } from '../../../Utils/Config';
import { apiCommonTrigger } from '../../../Utils/apiServicehelper';
import { Divider, Paper, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

const SubscriptionSuccess = (props) => {
    const accessKey = localStorage.getItem("accessKey");
    const dispatch = useDispatch();
    const [marketId, setmarketId] = useState(null);
    const search = useLocation().search;
    const token = new URLSearchParams(search).get('session_id');
    const { refid } = useParams();
    const navigate = useNavigate();
    const [isAccountActivated, setIsAccountActivated] = React.useState(0);
    const [billingInfoURL, setBillingInfoURL] = React.useState('')
    useEffect(() => {
        if (isAccountActivated === 0) {
            verifyToken();
        }
        if (refid) {
            getMarketDetails();
        }
    }, []);

    const getMarketDetails = async () => {
        try {
          let inputData = { "referenceid": refid };
          const result = await apiCommonTrigger(
            "post",
            `${Config.API_URL}/markets/market`,
            inputData
          );
          setmarketId(result?.data?.marketId);
        } catch (error) {
          handlingCatchError(error);
        }
      };

    // Activation key verification API
    const verifyToken = () => {
apiCommonTrigger("get",`${Config.API_URL}/subscription/checkout/`, [token])
            .then((res) => {
                if (res.status === 200) {
                    // if(res.data === "success" || res.data === "unpaid"){
                    setBillingInfoURL(res.headers.location);
                    setIsAccountActivated(1);
                    // }
                }
                else {
                    if (res.status === 400) {
                        setIsAccountActivated(2);
                    }
                    handlingCatchError(res, navigate);
                }
            })
            .catch(err => {
                handlingCatchError(err, navigate);
            })
    }

    var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;
    var isLoggedinUser = userDetails !== null && JSON.parse(userDetails).token !== "" && JSON.parse(userDetails).token !== undefined && JSON.parse(userDetails).token !== null ? true : false;

    return (
        <div className='thank-you-page'>
            <Container>
                <Row>
                    {isAccountActivated === 1 ?
                        refid ?
                            <Col xs={12}>
                                <div className="sec-msg">
                                    {marketId ? <Paper className="p-4 elevation0 thank-table" component="div" align="center" >
                                        <Typography variant="h3" component="h3" className="pb-4 thank-you" >
                                            Thank you for your purchase!
                                        </Typography>
                                        <Typography component="p" gutterBottom className="mb-3 btn-seperation-success">

                                            <Link onClick = {dispatch({ type: 'developmentFilters', value: [] })} to={`/market-dashboard/interactive-map/${marketId}`} target="_blank" className="market-btn btn btn-secondary">View Market</Link>

                                            <Link to={"/my-market"} target="_blank" className="market-btn btn btn-secondary">Go to My Markets</Link>

                                            <Link to={accessKey ? "/my-account" : "/signin"} target="_blank" className="market-btn btn btn-secondary">Go to my RVParkIQ Account</Link>
                                        </Typography>
                                        <Divider />
                                        <Typography component="p" className="pt-3 mb-0 font13 opacity-7" gutterBottom>
                                            Questions? Contact us at {Config.PhoneNumber} or <a href={'mailto:' + Config.supportEmail} className="email-conform">{Config.supportEmail}</a>
                                            {/* Questions? Contact us at {CONFIG.Sales} or */}
                                        </Typography>

                                    </Paper> : <p className='text-center please-wait-txt'>Please wait! Do not refresh/close the page your payment is processing...</p>}
                                </div>
                            </Col>
                            : <Col className='text-center'>
                                <div className='thank-u-center'>
                                    <h2>Your payment has been processed successfully.</h2>
                                    <p>Thank you for your payment. An automated payment reciept will be sent to your registered email!</p>
                                    <hr />
                                    <div className='support-msg'>
                                        <p>Having trouble? <a href={Config.ContactUrl}>Contact us</a></p>
                                        {isLoggedinUser ?
                                            <Link to={'/my-account'} className='market-btn'>Continue</Link>
                                            : <Link to={'/signin'} className='market-btn'>Continue to Log in</Link>}
                                        {/* <a href={billingInfoURL} className="view-billing">View Billing Details</a> */}
                                    </div>
                                </div>
                            </Col> :
                        isAccountActivated === 2 ?
                            <Col className='text-center'>
                                <div className='thank-u-center payment-failed'>
                                    <h2>Payment Failed!</h2>
                                    <p>Your Transaction has been failed. Please contact support for further assistance.</p>
                                    <hr />
                                    <div className='support-msg'>
                                        <p>Having trouble? <a href={Config.ContactUrl}>Contact us</a></p>
                                        <Link to={'/'} className='market-btn'>Go to Home</Link>
                                    </div>
                                </div>
                            </Col> :
                            <Col className='text-center'>
                                <p className='payment-process'>Please wait! Do not refresh the page your payment is processing... </p>
                            </Col>
                    }
                </Row>
            </Container>
        </div>
    );
}

export default SubscriptionSuccess;